const KEY_ACTIVE = 'agendamentos-app:guest:active'

export function markGuestSessionActive(): void {
  try {
    sessionStorage.setItem(KEY_ACTIVE, '1')
  } catch {
    /* ignore */
  }
}

export function clearGuestSession(): void {
  try {
    sessionStorage.removeItem(KEY_ACTIVE)
  } catch {
    /* ignore */
  }
}

export function isGuestSessionActive(): boolean {
  try {
    return sessionStorage.getItem(KEY_ACTIVE) === '1'
  } catch {
    return false
  }
}

/** Visitante a explorar a app sem sessão de cliente (modo Guest). */
export function isGuestClient(user: { id?: number } | null | undefined): boolean {
  return isGuestSessionActive() && !user
}
